import { FiltersCargo } from "../../stores/rh/cargo"
import { FiltersFuncionarios } from "../../stores/rh/funcionarios"
import { ApiError, ApiResponse } from "../../types/global/apiTypes"
import { Pagination } from "../../types/global/Paginacao"
import { Cargo, CargoResume } from "../../types/rh/cargo"
import { Funcionario, FuncionarioResume } from "../../types/rh/funcionario"
import { MotivoAfastamentoResume } from "../../types/rh/motivoAfastamento"
import { MotivoDemissaoResume } from "../../types/rh/motivoDemissao"
import { axiosInstance } from "../axiosInstance"
import handleAxiosError from "../handleAxiosError"
import { handleAxiosResponse } from "../handleAxiosResponse"

export const getfuncionarios = async (filters: FiltersFuncionarios): Promise<ApiResponse<Pagination<Funcionario>>> => {
  try {
    const response = await axiosInstance().post<Pagination<Funcionario> | ApiError>(`/rh/filter-funcionario`, filters)
    return handleAxiosResponse<Pagination<Funcionario>>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getCargos = async (filters: FiltersCargo): Promise<ApiResponse<Pagination<Cargo>>> => {
  try {
    const response = await axiosInstance().post<Pagination<Cargo> | ApiError>(`/rh/filter-cargo`, filters)
    return handleAxiosResponse<Pagination<Cargo>>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getCargosResume = async (): Promise<ApiResponse<CargoResume[]>> => {
  try {
    const response = await axiosInstance().get<CargoResume[] | ApiError>(`/rh/cargo-resume`)
    return handleAxiosResponse<CargoResume[]>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getMotivoDemissaoResume = async (): Promise<ApiResponse<MotivoDemissaoResume[]>> => {
  try {
    const response = await axiosInstance().get<MotivoDemissaoResume[] | ApiError>(`/rh/motivo-demissao-resume`)
    return handleAxiosResponse<MotivoDemissaoResume[]>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getMotivoAfastamentoResume = async (): Promise<ApiResponse<MotivoAfastamentoResume[]>> => {
  try {
    const response = await axiosInstance().get<MotivoAfastamentoResume[] | ApiError>(`/rh/motivo-afastamento-resume`)
    return handleAxiosResponse<MotivoAfastamentoResume[]>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getFuncionariosResume = async (): Promise<ApiResponse<FuncionarioResume[]>> => {
  try {
    const response = await axiosInstance().get<FuncionarioResume[] | ApiError>(`/rh/funcionario-resume`)
    return handleAxiosResponse<FuncionarioResume[]>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getFuncionarioById = async (id: number): Promise<ApiResponse<Funcionario>> => {
  try {
    const response = await axiosInstance().get<Funcionario | ApiError>(`/rh/funcionario/${id}`)
    return handleAxiosResponse<Funcionario>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const updateFuncionario = async (funcionario: Funcionario): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post<null | ApiError>(`/rh/update-funcionario`, funcionario)
    return handleAxiosResponse<null>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const createFuncionario = async (funcionario: Funcionario): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post<null | ApiError>(`/rh/create-funcionario`, funcionario)
    return handleAxiosResponse<null>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const deleteFuncionario = async (id: number): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().delete<null | ApiError>(`/rh/delete-funcionario/${id}`)
    return handleAxiosResponse<null>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const getCargoById = async (id: number): Promise<ApiResponse<Cargo>> => {
  try {
    const response = await axiosInstance().get<Cargo | ApiError>(`/rh/cargo/${id}`)
    return handleAxiosResponse<Cargo>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const updateCargo = async (cargo: Cargo): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post<null | ApiError>(`/rh/update-cargo`, cargo)
    return handleAxiosResponse<null>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const createCargo = async (cargo: Cargo): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().post<null | ApiError>(`/rh/create-cargo`, cargo)
    return handleAxiosResponse<null>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

export const deleteCargo = async (id: number): Promise<ApiResponse<null>> => {
  try {
    const response = await axiosInstance().delete<null | ApiError>(`/rh/delete-cargo/${id}`)
    return handleAxiosResponse<null>(response)

  } catch (error) {
    return handleAxiosError(error)
  }
}

